import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import Contact from '../components/Contact';
import Presence from '../components/Presence';

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Products />
      <Contact />
      <Presence/>
    </>
  );
}

export default Home;
